import { gql } from "@apollo/client";

// role: a single free-text role. It comes back localized when it matches one of
// the backend's proposals (e.g. "Sales Representative" reads "Vertriebsmitarbeiter"
// for a German identity) — display only, never a key.
// isLinked/sourceKind: when a contact resolves through an OTTO user or a
// service-provider contact (sourceKind != OWN), name/email/phone are live
// values from that source. They render read-only in the edit form (the update
// ignores them server-side); only the role stays editable.
export const ContactPersonFields = gql`
    fragment ContactPersonFields on ContactPerson {
        id
        firstName
        lastName
        name
        email
        phone
        isLinked
        sourceKind
        role
    }
`;
